import './DailyOverviewChart.css';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import StatusBadge from './StatusBadge';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const ExecutionTrendChart = ({ rawData, loading, error }) => {
  if (loading) return (
    <div className="empty-card">
      <div className="metric-header">
        <h2>Execution overview</h2>
        <StatusBadge status="loading" label="Loading" />
      </div>
      <div className="chart-box">
        <img className="flashing" style={{ height: '100%' }} src={require('../../assets/loading-chart.png')} alt="Loading chart" />
      </div>
    </div>
  );

  if (error) return (
    <div className="empty-card">
      <div className="metric-header">
        <h2>Execution overview</h2>
        <StatusBadge status="error" label="Error" className="flashing" />
      </div>
      <div className="chart-box">
        <img className="flashing" style={{ height: '100%' }} src={require('../../assets/error-chart.png')} alt="Error chart" />
      </div>
    </div>
  );

  if (!rawData || Object.keys(rawData).length === 0) return (
    <div className="empty-card">
      <div className="metric-header">
        <h2>Execution overview</h2>
        <StatusBadge status="no-data" label="No data" />
      </div>
      <div className="chart-box">
        <img style={{ height: '100%' }} src={require('../../assets/no-data-chart.png')} alt="No data chart" />
      </div>
    </div>
  );

  const labels = Object.keys(rawData).sort();

  const chartData = {
    labels,
    datasets: [
      {
        label: 'Failed',
        data: labels.map(d => rawData[d].failed || 0),
        backgroundColor: 'rgba(244, 67, 54, 0.8)',
      },
      {
        label: 'Passed',
        data: labels.map(d => rawData[d].passed || 0),
        backgroundColor: 'rgba(76, 175, 80, 0.8)',
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: 'index',
      intersect: false,
    },
    scales: {
      x: {
        stacked: true,
        ticks: { font: { size: 10 } },
      },
      y: {
        stacked: true,
        beginAtZero: true,
        ticks: { font: { size: 10 } },
      },
    },
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (ctx) => ` ${ctx.dataset.label}: ${ctx.raw}`,
        },
      },
    },
  };

  return (
    <div className="empty-card">
      <div className="metric-header">
        <h2>Execution overview</h2>
        <StatusBadge status="info" label="Info" />
      </div>
      <div style={{ flex: 1, minHeight: 0 }}>
        <Bar data={chartData} options={options} />
      </div>
    </div>
  );
};

export default ExecutionTrendChart;
